export enum InvoiceType {
    PAPER = 'paperBill',
    EBILL = 'eBill'
}